import { render, staticRenderFns } from "./ValidatorDataTable.vue?vue&type=template&id=0617c04c&scoped=true&"
import script from "./ValidatorDataTable.vue?vue&type=script&lang=ts&"
export * from "./ValidatorDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorDataTable.vue?vue&type=style&index=0&id=0617c04c&scoped=true&lang=scss&"
import style1 from "./ValidatorDataTable.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ValidatorDataTable.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617c04c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDataTable,VSwitch})
